module.exports = __webpack_public_path__ + "static/media/p0101.3ce05d4e.png";